import moment from 'moment'
import { arrayIt } from '@/utils'

export default {
	/**
	 * Sets the leads data for the page based on our initial API Request
	 * @param {Object} state the application state.
	 * @param {Object} payload the API response body
	 *
	 * @returns {void}
	 */
	setLeadsPageData (state, payload) {
		state.filterOptions.sites     = payload.sites
		state.filterOptions.campaigns = payload.campaigns
		state.filterOptions.tags      = payload.tags
		state.leads                   = payload.leads
		state.page                    = parseInt(payload.pagination.currentPage)
		state.perPage                 = parseInt(payload.pagination.perPage)
		state.count                   = parseInt(payload.pagination.count)
	},

	removeLead (state, leadId) {
		const index = state.leads.findIndex(lead => leadId === lead.id)
		state.leads.splice(index, 1)
	},

	resetLeads (state) {
		state.leads = []
	},

	setPage (state, payload) {
		state.page = payload
	},

	updateSiteFilters (state, payload) {
		state.filters.sites = arrayIt(payload)
	},

	updateCampaignFilters (state, payload) {
		state.filters.campaigns = arrayIt(payload)
	},

	updateTagFilters (state, payload) {
		state.filters.tags = arrayIt(payload)
	},

	updateStartDate (state, payload) {
		state.filters.dateRangeStart = moment(payload).format('YYYY-MM-DD')
	},

	updateEndDate (state, payload) {
		state.filters.dateRangeEnd = moment(payload).format('YYYY-MM-DD')
	},

}
